import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllCashDepositsService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const accountId = +urlQueries["account-id"] || "";
  const created_between = urlQueries["created_between"] || "";
  const allCashDepositsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CASH_DEPOSITS,
      page,
      debouncedQuery,
      per_page,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CASH_DEPOSITS,
        searchParams: {
          page,
          "filter[account_id]": accountId,
          "filter[created_between]": created_between,
          include: "partner,account",
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allCashDepositsService },
    states: { searchQuery, setSearchQuery },
  };
};
